export enum NoViewsActions {
  CreateNew = 'Create New',
  UploadSite = 'Upload Site',
}
